<template>
  <div class="content">
    <el-tabs
      class="tabLv3"
      type="border-card"
      v-model="tabName"
    ><i class="lt"></i><i class="rt"></i>
      <el-tab-pane name="xjrwgl">
        <span slot="label"><i class="iconfont iconcheck"></i><i class="border"></i> 隐患录入</span>
        <normalNav :parent="self">
          <button
            class="GreenSmBtn"
            @click="edit"
          >录入</button>
        </normalNav>
        <div class="searchForm1">
          <searchForm
            :items="items"
            :formPlus="form_xjrwgl"
            ref="searchForm_xjrwgl"
          >
          </searchForm>
        </div>
        <div class="tableWrapper">
          <easyTable
            apiUrl="operation/risk/query_page"
            :parent="self"
            :config="config"
            :other="other"
            ref="table_xjrwgl"
          ></easyTable>
        </div>
        <el-dialog
          class="editDialog"
          title="隐患录入"
          :visible.sync="editDialogVisible"
          :close-on-click-modal="false"
          @close="cancel"
        >
          <section
            class="list"
            v-if="editDialogVisible"
          >
            <el-form
              ref="form1"
              :model="form1"
              :rules="rule"
            >
              <el-form-item
                label="隐患类型："
                prop="riskType"
              >
                <el-select
                  class="darkSelect"
                  :popper-append-to-body="false"
                  v-model="form1.riskType"
                  filterable
                  default-first-option
                  placeholder="请选择"
                  style="width:auto;"
                >
                  <el-option
                    v-for="item in yhlx"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                label="地点选择"
                prop="regionName"
              >
                <el-input
                  v-model="form1.regionName"
                  placeholder="请选择地点"
                  @focus="addAreaTreeVisible=true"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="审核部门:"
                prop="dept_id"
              >
                <searchCompany
                  @changeCompany="changeCompany"
                  ref="searchCompany"
                ></searchCompany>
              </el-form-item>

              <el-form-item
                label="隐患信息："
                prop="content"
              >
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  v-model="form1.content"
                  maxlength="150"
                >
                </el-input>
              </el-form-item>

              <el-form-item
                label="上传图片："
                prop="fileList"
              >
                <el-upload-secondary
                  class="YnormalCard"
                  v-model="form1.fileList"
                  list-type="picture-card"
                  accepts="jpg,jpeg,png"
                >
                  <i class="el-icon-plus"></i>
                </el-upload-secondary>
                <div
                  class="el-form-item__error"
                  v-show="!form1.fileList||form1.fileList.length==0"
                  slot="error"
                >
                  请上传图片
                </div>
              </el-form-item>

            </el-form>
          </section>

          <div
            slot="footer"
            class="dialog-footer"
          >
            <el-button
              class="cancelButton"
              type="primary"
              @click="cancel"
            >取消</el-button>
            <el-button
              class="confirmButton"
              type="primary"
              @click="submit"
            >提交</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>

    <mountPoint
      :hasChildNodes="true"
      :dialogVisible="addAreaTreeVisible"
      @regionTreeClose="addAreaTreeVisible=false"
      @regionTreeData="addSelRegionData"
    ></mountPoint>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { yhzt, obj2urlsp, descriptor } from "utils";
export default {
  data() {
    return {
      tabName: "xjrwgl",
      addAreaTreeVisible: false,
      yhzt,
      form_xjrwgl: {},
      editLoading: true,
      editDialogVisible: false,
      other: {
        subUser: 0,
      },
      form1: {},
    };
  },
  computed: {
    ...mapGetters("Dictionary", ["yhdj", "yhlx"]),
    items() {
      const that = this;
      return [
        {
          type: "input",
          prop: "flowId",
          label: "隐患编号",
          placeholder: "",
        },
        {
          type: "start",
          prop: "startTime",
          label: "开始时间",
        },
        {
          type: "end",
          prop: "endTime",
          label: "结束时间",
        },
        {
          type: "select",
          prop: "riskType",
          label: "隐患类型",
          option: {
            option: that.yhlx,
          },
        },
        {
          type: "select",
          prop: "status",
          label: "隐患状态",
          option: {
            option: yhzt,
          },
        },
      ];
    },
    self() {
      return this;
    },
    config() {
      return [
        {
          prop: "flowId",
          label: "隐患编号",
        },
        {
          prop: "createTime",
          label: "上报时间",
        },
        {
          prop: "riskTypeDesc",
          label: "隐患类型",
        },
        {
          prop: "areaName",
          label: "隐患地点",
        },
        {
          prop: "content",
          label: "隐患内容",
        },
        {
          prop: "curDeptName",
          label: "审核部门",
        },
        {
          prop: "statusDesc",
          label: "隐患状态",
        },
      ];
    },
    rule() {
      let that = this;
      return {
        riskType: descriptor(new Map([[true, "请选择隐患类型"]]), "blur"),
        regionName: descriptor(new Map([[true, "请选择隐患地点"]]), "blur"),
        dept_id: descriptor(new Map([[true, "请选择审核部门"]]), "blur"),
        // fileList: descriptor(new Map([
        //   [true, "请选择图片"]
        // ]), "change"),
        content: descriptor(new Map([[true, "请填写隐患内容"]]), "blur"),
      };
    },
    urls() {
      if (!this.form1.fileList) return;
      return this.form1.fileList
        .map((o) => o.response.data[0].startsWith('http') ? o.response.data[0] : `${process.env.fileUrl}/${o.response.data[0]}`).join(";");
    },
  },
  methods: {
    reset_xjrwgl(fn) {
      fn();
      this.form_xjrwgl = {};
    },
    search_xjrwgl(fn) {
      fn();
    },
    edit() {
      this.editDialogVisible = true;
    },
    cancel() {
      this.editDialogVisible = false;
      this.form1 = {};
    },
    submit() {
      this.$refs["form1"].validate((valid) => {
        if (valid) {
          this.$axiospost("operation/risk/new", {
            riskType: this.form1.riskType, // 隐患类型
            areaId: this.form1.area_id, // 区域编号
            areaDetail: null, // 隐患区域详细地址
            content: this.form1.content, // 隐患详情
            pic: this.urls, // 附件 分号分割
            curDept: this.form1.dept_id, //审核部门
            curGroup: null, // 组
            curEmp: null, // 员工
          }).then((res) => {
            this.$refs["table_xjrwgl"].getData();
            this.editDialogVisible = false;
          });
        }
      });
    },
    addSelRegionData(data) {
      this.$set(this.form1, "regionName", data.name);
      this.$set(this.form1, "area_id", data.id);
    },
    changeCompany(dept_id) {
      this.$set(this.form1, "dept_id", dept_id);
    },
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    easyTable: () => import("public/easyTable"),
    mountPoint: () => import("./mountPoint/"),
    searchCompany: () => import("public/searchCompany"),
  },
  mounted() {
    // this.$message({
    //   duration: 6000,
    //   message: '这是一条消息提示'
    // });
    // this.$notify.info({
    //   title: '消息',
    //   message: '这是一条消息的提示消息',
    //   duration: 6000,
    // });
    // this.$message({
    //   duration: 5000,
    //   message: '恭喜你，这是一条成功消息',
    //   type: 'success'
    // });
    // this.$notify({
    //   title: '成功',
    //   message: '这是一条成功的提示消息',
    //   type: 'success',
    //   duration: 5000,
    // });
    // this.$message({
    //   duration: 4000,
    //   message: '警告哦，这是一条警告消息',
    //   type: 'warning'
    // });
    // this.$notify({
    //   title: '警告',
    //   message: '这是一条警告的提示消息',
    //   type: 'warning',
    //   duration: 4000,
    // });
    // this.$message({
    //   duration: 3000,
    //   message: '错了哦，这是一条错误消息',
    //   type: 'error'
    // });
    // this.$notify.error({
    //   title: '错误',
    //   message: '这是一条错误的提示消息',
    //   type: 'error',
    //   duration: 3000,
    // });
  },
};
</script>

<style lang="less" scoped>
.point {
  span {
    padding-left: 5px;
    color: #fff;
    font-size: 14px;
    display: inline-block;
    height: 14px;
    line-height: 14px;
    border-left: 2px solid #35b9f7;
  }

  border-bottom: 1px solid #777;
  line-height: 36px;
  margin-top: 15px;
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/yinhuan/report/index.vue